type SeoScriptProps = {
  data: Record<string, unknown>;
};

export default function SeoScript({ data }: SeoScriptProps) {
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}